// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#errorPage #SnippyError{overflow:hidden;border-radius:500px;width:450px;height:450px;background:var(--text-default);display:flex;align-items:center;justify-content:center;animation:spin 5s linear infinite;transform-origin:650}@keyframes spin{to{transform:rotate(1turn)}}#errorPage img{margin:auto;width:500px;height:500px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
